/* eslint-disable @angular-eslint/component-class-suffix */
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';
import { DialogsService } from '../dialogs.service';
import { NextTaskTypeForm } from '../../core/task-type/task-type.types';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation/confirmation.service';
import { Task } from '../../modules/admin/tasks/tasks.types';

@Component({
    selector: 'new-form-reply-dialog',
    templateUrl: './new-form-reply-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewFormReplyDialog implements OnInit {

    control: FormControl = new FormControl<string>('', Validators.required);
    forms: NextTaskTypeForm[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            forms: NextTaskTypeForm[];
            task: Task;
        },
        public dialogRef: MatDialogRef<NewFormReplyDialog>,
        private dialogsService: DialogsService,
        private _fuseConfirmationService: FuseConfirmationService,
        private transloco: TranslocoService,
    ) { }

    ngOnInit() {
        this.forms = this.data.forms
        .filter(form =>
            !form.deprecated &&
            (form.visiblePlanningAreaId.length === 0
                || form.visiblePlanningAreaId.includes(this.data.task.serverPayload.planningAreaId))
            && (form.visibleWorkDayTypeId.length === 0
                || form.visibleWorkDayTypeId.includes(this.data.task.serverPayload.schedule?.workDayType?._oid)));
    }

    getForm() {
        const confirmDialog = this.openConfirmDialog();
        confirmDialog.afterClosed().subscribe((confirm) => {
            if (confirm === 'confirmed') {
                this.control.markAsTouched();
                if (this.control.valid) {
                    this.dialogRef.close(this.control.value);
                } else {
                    this.dialogsService.openErrorDialog({
                        message: this.transloco.translate('errorsInForm')
                    });
                }
            }
        });
    }

    closeDialog(form?: NextTaskTypeForm) {
        this.dialogRef.close(form);
    }

    private openConfirmDialog() {
        return this._fuseConfirmationService.open({
            title: this.transloco.translate('warning'),
            message: this.transloco.translate('newFormReplyMsg'),
            actions: {
                confirm: {
                    label: this.transloco.translate('confirm')
                },
                cancel: {
                    label: this.transloco.translate('cancel')
                }
            }
        });
    }

}
